import { render, staticRenderFns } from "./UpdateBankStatement.vue?vue&type=template&id=2b41cca3&scoped=true&"
import script from "./UpdateBankStatement.vue?vue&type=script&lang=ts&"
export * from "./UpdateBankStatement.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateBankStatement.vue?vue&type=style&index=0&id=2b41cca3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41cca3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VInput,VRow})
